import React, { useRef, useState } from 'react'
import styled from 'styled-components'

import pauseIcon from '../../../../assets/player/pauseIcon.png'
import playIcon from '../../../../assets/player/playIcon.png'

const PlayerContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
`

const VideoBox = styled.video`
  width: 100%;
  height: 55%;
`
const VideoControls = styled.div`
  width: 45%;
  height: 50px;
`
const StopPauseButton = styled.button`
  width: 45px;
  height: 45px;
  border: 2px solid #fe0da0;
  border-radius: 50%;

  background: ${(props) =>
    props.videoState ? `url(${pauseIcon})` : `url(${playIcon})`};
  background-size: 30%;
  background-repeat: no-repeat;
  background-position: center;
`

const ProgressBar = styled.div`
  width: 50%;
  height: 10px;
  background-color: red;
`

const Player = ({ videoURL }) => {
  const videoEl = useRef(null)
  const [videoState, setVideoState] = useState(null)
  const play = (e) => {
    if (videoEl.current.paused) {
      videoEl.current.play()
    } else {
      videoEl.current.pause()
    }

    setVideoState(!videoState)
  }

  return (
    <PlayerContainer>
      <VideoBox ref={videoEl} onClick={(e) => play(e)} preload="metadata">
        <source src={`${videoURL}`} type="video/mp4" />
      </VideoBox>
      <VideoControls>
        <StopPauseButton
          videoState={videoState}
          onClick={(e) => play(e)}
        ></StopPauseButton>
        <ProgressBar></ProgressBar>
      </VideoControls>
    </PlayerContainer>
  )
}

export default Player
